import styles from './index.scss'
import { CheckCircleFill } from 'antd-mobile-icons'
import SpecsDetail from '@/libs/components/DpBusinessComponents/DpBusinessSpecs/detail'
import classnames from 'classnames'
import { RecordType, IDpBusinessCommodityAddCommodity } from './index'
import DpFlex from '@/libs/components/DpFunctionComponents/DpFlex'
export const transformSpecDetailText = (specDetail: any) =>
  specDetail
    ? String(Object.values(JSON.parse(specDetail))).replace(',', '、')
    : ''
const AddCommodityList = (props: IDpBusinessCommodityAddCommodity) => {
  return (
    <>
      {props?.data?.map?.((item: RecordType, index: number) => {
        return (props?.maxLength || 1000) > index && (
          <div key={index} className={
            classnames([
              styles["dp-business-commodity--add-item"],
              {[styles['dp-business-commodity--add-item-last']]: props?.maxLength === (index + 1) || props?.data?.length === (index + 1)}
            ])
          }>
            <DpFlex>
              <DpFlex.Item>
                <div
                  className={styles["dp-business-commodity--add-item-image"]}
                  style={{ ...props?.imgStyles, backgroundImage: `url(${item?.skuImage || item?.listViewUrl})` }}
                >
                </div>
              </DpFlex.Item>
              <DpFlex.Item style={{ flex: 1, paddingLeft: 8 }}>
                <DpFlex type='spaceBetween' style={{ paddingBottom: 8 }}>
                  <DpFlex.Item>
                    <span className={styles["dp-business-commodity--add-item-name"]}>{item?.proName}</span>
                  </DpFlex.Item>
                  <DpFlex.Item>
                    <span className={styles["dp-business-commodity--add-item-name"]}>￥{item?.exchangePrice}</span>
                  </DpFlex.Item>
                </DpFlex>
                <DpFlex type='spaceBetween'>
                  <DpFlex.Item className={styles['dp-business-commodity--add-item-tips']}>
                    <span style={{ marginRight: 6 }}>{transformSpecDetailText(item?.specDetail)}</span>
                    <span>x1</span>
                  </DpFlex.Item>
                  <DpFlex.Item>
                    {
                      (item?.specProDetail || item.proDetail) &&
                        <SpecsDetail
                          proDetail={item}
                          name={'详情'}
                          title={transformSpecDetailText(item?.specDetail)}
                          data={{
                            ...item,
                            specProDetail: item?.specProDetail || item.proDetail
                          }}
                          style={{ fontSize: 12, color: 'rgb(155, 155, 155)' }}
                        />
                    }
                  </DpFlex.Item>
                </DpFlex>
              </DpFlex.Item>
              <DpFlex.Item>
                <div
                  className={styles['dp-business-commodity--add-item-icon']}
                  onClick={() => props?.onChange?.(item)}
                >
                  {props?.value?.find((_item: RecordType) => _item?.[props?.rowKey || 'id'] === item?.[props?.rowKey || 'id']) ? (
                    <CheckCircleFill className={styles['dp-business-commodity--add-item-icon-yes']} />
                  ) : (
                    <span className={styles['dp-business-commodity--add-item-icon-round']} ></span>
                  )}
                </div>
              </DpFlex.Item>
            </DpFlex>
          </div>
        )
      })}
    </>
  )
}
export default AddCommodityList